module.exports = [
  "ad",
  "ao",
  "ai",
  "ag",
  "ar",
  "aw",
  "au",
  "at",
  "bs",
  "bb",
  "be",
  "bz",
  "bj",
  "bm",
  "bo",
  "bw",
  "br",
  "vg",
  "bf",
  "cm",
  "ca",
  "cv",
  "ky",
  "cf",
  "td",
  "cl",
  "co",
  "ck",
  "cr",
  "cu",
  "cw",
  "cd",
  "dk",
  "dm",
  "do",
  "ec",
  "sv",
  "gq",
  "ee",
  "fo",
  "fj",
  "fi",
  "fr",
  "ga",
  "gm",
  "ge",
  "de",
  "gi",
  "gl",
  "gd",
  "gt",
  "gg",
  "gn",
  "gw",
  "gy",
  "ht",
  "hn",
  "is",
  "ie",
  "im",
  "it",
  "ci",
  "jm",
  "je",
  "ke",
  "ki",
  "la",
  "lv",
  "ls",
  "lr",
  "li",
  "lt",
  "lu",
  "mg",
  "mw",
  "mv",
  "ml",
  "mt",
  "mh",
  "mu",
  "mx",
  "fm",
  "mc",
  "mz",
  "nr",
  "nl",
  "nz",
  "ni",
  "ne",
  "nu",
  "no",
  "pw",
  "pa",
  "pg",
  "py",
  "pe",
  "pt",
  "pr",
  "cg",
  "ro",
  "rw",
  "kn",
  "lc",
  "ws",
  "sm",
  "st",
  "sn",
  "sc",
  "sl",
  "sg",
  "sb",
  "za",
  "es",
  "vc",
  "sr",
  "sz",
  "se",
  "ch",
  "tz",
  "tl",
  "tg",
  "tt",
  "tr",
  "tc",
  "tv",
  "ug",
  "gb",
  "uy",
  "us",
  "vu",
  "ve",
  "zm"
]
